import React from 'react'
import './sideDrawerMenu.scss'

const SideDrawerMenu = (props) => {

    let style = {
        height: 'calc(-130px + 100vh)',
        top: 'calc(100vh - ((-128px) + 100vh))',
        right: props.right ? "23.4375vw" : '',
        width: props.width
    }
    return (
        <div className='side-Drawer-model-container' style={style}>
            {/* <h3 onClick={props.handleClose} className='close-button'>X</h3> */}
            {props.children}
        </div>
    )
}

export default SideDrawerMenu
